import { render, staticRenderFns } from "./LayoutHeaderTabs.vue?vue&type=template&id=6887f794"
import script from "./LayoutHeaderTabs.vue?vue&type=script&lang=js"
export * from "./LayoutHeaderTabs.vue?vue&type=script&lang=js"
import style0 from "./LayoutHeaderTabs.vue?vue&type=style&index=0&id=6887f794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports